import * as React from 'react';
import { observer } from 'mobx-react';
import { SvgIcon, SvgProperties } from '../svg-icon';
import { Text } from '../text';

import { tabs, tab, label, button, icon, active } from './tabs.less';

export interface ITabOption {
	label: string;
	value: number;
	acceptanceTestTargetId: string;
	icon?: SvgProperties;
}

@observer
export class Tabs extends React.Component<{
	selectedTab: number;
	onChange: (value: number) => void;
	options: ITabOption[];
},{}> {
	render() {
		const { selectedTab, options } = this.props;
		const tabStyle = { width: `${100/options.length}%` };

		return (
			<ul className={tabs}>
				{options.map((option) => <Tab key={option.value} isActive={selectedTab === option.value} onSelect={this.onSelect} style={tabStyle} {...option} />)}
			</ul>
		);
	}

	onSelect = (event: React.MouseEvent<HTMLButtonElement>) => {
		this.props.onChange(Number(event.currentTarget.value));
	}
}

export class Tab extends React.Component<{
	value: number;
	label: string;
	acceptanceTestTargetId: string;
	onSelect: (event: React.MouseEvent<HTMLButtonElement>) => void;
	isActive: boolean;
	style?: React.CSSProperties;
	icon?: SvgProperties;
},{}> {
	render() {
		const { label: tabLabel, value, onSelect, isActive, acceptanceTestTargetId, style } = this.props;
		const svgIcon = this.props.icon as SvgProperties;

		return (
			<li role="presentation" className={`${tab} ${isActive ? active : ''}`} style={style}>
				<button className={`${button} ${isActive ? 'brand-primary-border-bottom' : ''}`}
					type="button"
					value={value}
					onClick={onSelect}
					data-pp-at-target={acceptanceTestTargetId}
				>
					{svgIcon && <SvgIcon svg={svgIcon} className={`${icon} hidden-xs`} role="presentation" />}
					<span className={label}><Text>{tabLabel}</Text></span>
				</button>
			</li>
		);
	}
}
